import { CatalogItemListFilter } from '@common/model/catalog/item/list.filter';
import { RangeInputValue } from '@cp/ds/src/components/form/components/field/range/model';
import { format } from 'date-fns';
import { dateOnlyISOStringToDateObj } from '@cp/shared/lib';
import { DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT } from '@cp/ds/src/components/form/components/field/dateTimePicker/const';
import { FormAvailableOnlyFieldName } from 'src/entities/catalog/ui/availableOnly/model';
import { FormFieldName, FormModel } from '../form';
import { numericToBool } from './numericToBool';
import { toNumberArray } from './toNumberArray';

export const getDefaultValues = (defaultFilter: CatalogItemListFilter): FormModel => {
  const formValues: FormModel = {
    // [FormFieldName.Online]: typeof defaultFilter.isOnline === 'number' ? Boolean(defaultFilter.isOnline) : null,
    [FormFieldName.Price]:
      typeof defaultFilter.priceMin === 'number' && typeof defaultFilter.priceMax === 'number'
        ? [defaultFilter.priceMin, defaultFilter.priceMax]
        : null,
    [FormFieldName.ChildrenCount]: defaultFilter.childrenCount ?? null,
    [FormFieldName.Training]: numericToBool(defaultFilter.training),
    [FormFieldName.Permanent]: null,
    [FormFieldName.Baby]: numericToBool(defaultFilter.baby),
    [FormFieldName.ChildWithDisabilities]: numericToBool(defaultFilter.childWithDisabilities),
    [FormFieldName.Options]: toNumberArray(defaultFilter.options),
    [FormFieldName.Age]: typeof defaultFilter.age === 'object' ? (toNumberArray(defaultFilter.age) as RangeInputValue) : undefined,
    [FormAvailableOnlyFieldName.AvailableOnly]: Boolean(defaultFilter.date),
    [FormAvailableOnlyFieldName.Date]: defaultFilter.date
      ? format(dateOnlyISOStringToDateObj(new Date(defaultFilter.date).toISOString()), DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT)
      : null,
    [FormAvailableOnlyFieldName.Start]: defaultFilter.start ?? null,
    [FormAvailableOnlyFieldName.End]: defaultFilter.end ?? null,
    [FormFieldName.DateStart]: defaultFilter.start ?? null,
    [FormFieldName.DateEnd]: defaultFilter.end ?? null,
  };

  return formValues;
};
